module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"GeoMap","missing":"Some nodes could not be positioned and will not be displayed on the map.","error":"We couldn\u0027t find any nodes to display on the map..."}}')
  delete Component.options._Ctor
}
